import React from "react";
import { ReviewList } from "ComponentsUI/Reviews";

const data = [
	{
		answers: {
			count: 1,
			list: [{}],
		},
	},
	{
		answers: {
			count: 1,
			list: [{}],
		},
	},
];

export default class ReviewsBStub extends React.Component {
	render() {
		return (
			<React.Fragment>
				<ReviewList data={data} stub={true} />
			</React.Fragment>
		);
	}
}
